
import React from 'react';
import { 
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import { FolderPlus, Upload } from 'lucide-react';

type FilesContextMenuProps = {
  children: React.ReactNode;
  onCreateFolder: () => void;
  onUploadFiles: () => void;
};

export function FilesContextMenu({ 
  children, 
  onCreateFolder,
  onUploadFiles 
}: FilesContextMenuProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>
        {children}
      </ContextMenuTrigger>
      <ContextMenuContent className="w-52">
        <ContextMenuItem onClick={onCreateFolder} className="cursor-pointer">
          <FolderPlus className="mr-2 h-4 w-4" />
          Nova Pasta
        </ContextMenuItem>
        <ContextMenuItem onClick={onUploadFiles} className="cursor-pointer">
          <Upload className="mr-2 h-4 w-4" />
          Upload de Arquivos
        </ContextMenuItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
